import { useOrdersControllerGiftGetByTokenQuery } from '@app/api/ordersApi/orders-api';
import { toGift } from '@app/api/mappers';
import { TGift } from '@app/models';
import { useMemo } from 'react';

type QueryResult = ReturnType<typeof useOrdersControllerGiftGetByTokenQuery>;
type UseGiftQueryReturn = Omit<QueryResult, 'data'> & {
  data?: TGift;
};

export const useGiftQuery = (token: string): UseGiftQueryReturn => {
  const result = useOrdersControllerGiftGetByTokenQuery({ token });

  const transformedData = useMemo(() => {
    if (!result.data) return undefined;
    return toGift(result.data);
  }, [result.data]);

  return {
    ...result,
    data: transformedData,
  };
};
